export default __webpack_public_path__ + "static/media/frosty3.9cb5f5f5.png";